import { Link } from 'react-router-dom';
import { FiArrowRight, FiShield, FiZap, FiStar, FiUsers, FiMapPin, FiCheckCircle, FiHeadphones, FiGlobe } from 'react-icons/fi';
import Navbar from '../shared/Navbar.jsx';
import BottomNav from '../shared/BottomNav.jsx';
import '../home/Home.css';
import './About.css';

const VALEURS = [
	{ icon: FiShield,     titre: 'Confiance & sécurité',    texte: 'Toutes les agences partenaires sont vérifiées, agréées et notées. Vos données et paiements sont chiffrés de bout en bout.' },
	{ icon: FiZap,        titre: 'Rapidité & simplicité',   texte: 'Réservez en moins de 2 minutes. Notre interface épurée vous guide sans friction, de la recherche au paiement.' },
	{ icon: FiStar,       titre: 'Sélection premium',       texte: 'Nous ne référençons que des véhicules récents, bien entretenus et conformes à nos standards de qualité stricts.' },
	{ icon: FiHeadphones, titre: 'Support 7j/7',            texte: 'Une équipe dédiée répond à vos questions et résout vos problèmes à toute heure. Vous n\'êtes jamais seul.' },
];

const CHIFFRES = [
	{ valeur: '50+',     label: 'Agences partenaires' },
	{ valeur: '1 200+',  label: 'Véhicules disponibles' },
	{ valeur: '4,8/5',   label: 'Note moyenne clients' },
	{ valeur: '100%',    label: 'Couverture nationale' },
];

const GARANTIES = [
	'Annulation gratuite sous 24h',
	'Prix affichés toutes taxes comprises',
	'Assurance incluse sur chaque réservation',
	'Assistance routière disponible',
	'Véhicules nettoyés et désinfectés',
	'Support client réactif',
];

function About() {
	return (
		<div className="ab-page">
			<Navbar />

			<main>
				{/* ── HERO ── */}
				<section className="ab-hero">
					<div className="ab-hero-glow" aria-hidden="true" />
					<div className="ab-hero-glow ab-hero-glow-2" aria-hidden="true" />
					<div className="vx-shell ab-hero-inner">
						<div className="ab-hero-kicker">
							<span className="ab-dot" />
							Notre histoire
						</div>
						<h1 className="ab-hero-title">
							La location de voiture,<br />
							<em>réinventée au Maroc.</em>
						</h1>
						<p className="ab-hero-sub">
							UltimateX Drive est né d'un constat simple : louer une voiture au Maroc était trop compliqué, trop opaque, trop risqué. Nous avons tout repensé — de la recherche au retour des clés — pour vous offrir une expérience fluide, transparente et premium.
						</p>
						<div className="ab-hero-actions">
							<Link to="/search" className="ab-btn-blue">
								Explorer la flotte <FiArrowRight size={14} />
							</Link>
							<Link to="/contact" className="ab-btn-ghost">
								Nous contacter
							</Link>
						</div>
					</div>
				</section>

				{/* ── STATS ── */}
				<section className="ab-stats-section">
					<div className="vx-shell">
						<div className="ab-stats">
							{CHIFFRES.map((c) => (
								<div key={c.label} className="ab-stat">
									<span className="ab-stat-value">{c.valeur}</span>
									<span className="ab-stat-label">{c.label}</span>
								</div>
							))}
						</div>
					</div>
				</section>

				{/* ── MISSION ── */}
				<section className="ab-section ab-mission-section">
					<div className="vx-shell ab-mission">
						<div className="ab-mission-text">
							<div className="ab-section-kicker">
								<FiUsers size={13} aria-hidden="true" /> Notre mission
							</div>
							<h2 className="ab-section-title">
								Connecter les voyageurs aux meilleures agences locales
							</h2>
							<p>
								Nous mettons en relation des milliers de conducteurs avec des agences rigoureusement sélectionnées à travers le Maroc. Chaque annonce est vérifiée, chaque véhicule est inspecté.
							</p>
							<p>
								Notre IA analyse vos besoins et recommande le véhicule le plus adapté — en tenant compte de votre budget, de votre destination et de vos préférences.
							</p>
						</div>
						<div className="ab-coverage-card">
							<div className="ab-coverage-icon">
								<FiGlobe size={32} />
							</div>
							<strong>Disponible dans tout le Maroc</strong>
							<p>De Tanger à Dakhla, nos agences partenaires couvrent l'ensemble du territoire national. Où que vous alliez, UltimateX Drive est là.</p>
							<div className="ab-coverage-badge">
								<FiMapPin size={12} /> Couverture nationale
							</div>
						</div>
					</div>
				</section>

				{/* ── VALEURS ── */}
				<section className="ab-section">
					<div className="vx-shell">
						<div className="ab-section-head">
							<div className="ab-section-kicker">Ce qui nous distingue</div>
							<h2 className="ab-section-title">Nos engagements</h2>
						</div>
						<div className="ab-values">
							{VALEURS.map((v, i) => (
								<div key={v.titre} className="ab-value-card" style={{ '--delay': `${i * 0.1}s` }}>
									<div className="ab-value-icon-wrap">
										<v.icon size={20} aria-hidden="true" />
									</div>
									<h3>{v.titre}</h3>
									<p>{v.texte}</p>
								</div>
							))}
						</div>
					</div>
				</section>

				{/* ── CTA AGENCE ── */}
				<section className="ab-section ab-cta-section">
					<div className="ab-cta-glow" aria-hidden="true" />
					<div className="vx-shell ab-cta">
						<div className="ab-section-kicker">Vous êtes une agence ?</div>
						<h2 className="ab-section-title">Rejoignez le réseau UltimateX Drive</h2>
						<p>
							Vous gérez une flotte de véhicules ? Rejoignez notre réseau de partenaires et accédez à des milliers de clients qualifiés. Inscription gratuite, gestion simplifiée.
						</p>
						<div className="ab-cta-btns">
							<Link to="/signupagence" className="ab-btn-blue">
								Devenir partenaire <FiArrowRight size={14} />
							</Link>
							<Link to="/contact" className="ab-btn-ghost">
								Nous contacter
							</Link>
						</div>
					</div>
				</section>

				{/* ── GARANTIES ── */}
				<section className="ab-section">
					<div className="vx-shell">
						<div className="ab-section-head">
							<div className="ab-section-kicker">Nos garanties</div>
							<h2 className="ab-section-title">Ce qu'on vous promet</h2>
						</div>
						<div className="ab-guarantees">
							{GARANTIES.map((g) => (
								<div key={g} className="ab-guarantee">
									<FiCheckCircle size={16} aria-hidden="true" />
									<span>{g}</span>
								</div>
							))}
						</div>
					</div>
				</section>
			</main>

			<BottomNav />
		</div>
	);
}

export default About;
